import { useState } from 'react';
import { config } from '../config';

export interface UserProfile {
    email: string;
    role: string;
}

export function useAuth() {
    const [user] = useState<UserProfile | null>(() => {
        const email = localStorage.getItem(config?.USER_EMAIL_KEY);
        const storedRole = localStorage.getItem(config?.USER_ROLE_KEY);
        const role = storedRole || 'customer';
        return email ? { email, role: role.toUpperCase() } : null;
    });

    return { user };
}
